function goBack() {
	window.history.back();
}

function inputMasked() {
	$("._mask-tel").inputmask("+[9] (999) 999-99-99", {
		showMaskOnHover: false
	});
	$("._mask-price").inputmask("9{1,} ₽", {
		showMaskOnHover: false
	});
	$("._mask-time").inputmask({
		regex: "([0-1][0-9]|[2][0-3]):([0-5][0-9]) - ([0-1][0-9]|[2][0-3]):([0-5][0-9])",
		showMaskOnHover: false
	});

	$("._mask-date").inputmask("99/99/9999", {
		showMaskOnHover: false
	});
}

$(function () {
	// Обрезаем заголовки в карточках, если они занимают более 3-х строк и 2-х строк для описаний
	function clampText() {
		const headers = document.querySelectorAll(".card__title");
		const descrs = document.querySelectorAll(".card__descr");

		const cutListeners = function (elems, noCutClass, cutStrokeNumber) {
			elems.forEach(function (item) {
				const parent = item.closest(".card");
				const isNoCut = parent.classList.contains(noCutClass);

				if(isNoCut) {} else {
					$clamp(item, {
						clamp: cutStrokeNumber
					});
				}
			});
		};

		cutListeners(headers, "js-no-title-cut", 3);
		cutListeners(descrs, "js-no-descr-cut", 2);
	}

	$(window).on('resize', function () {
		clampText();
	});

	clampText();

	// Присваиваем классы активным пунктам меню
	var location = document.location.pathname;
	var cur_url = "/" + location.split("/")[1];

	if (cur_url == "//") {
		cur_url = "/";
	}

	$("nav li a").each(function () {
		var link = $(this).attr("href");

		if(cur_url === link || cur_url + "/" === link) {
			$(this).addClass("current");
		}
	});

	$(".header-buttons a").each(function () {
		var link = $(this).attr("href");

		if(cur_url === link || cur_url + "/" === link) {
			$(this).addClass("current");
		}
	});

	// selectize
	$(".js-select").selectize({
		persist: false,
		onInitialize() {
		    console.log(123);
		    console.log(this.$input.data('search'));
		    if (this.$input.data('search') === undefined) {
                console.log(333);
                this.$wrapper.find(".selectize-input input").attr('disabled', '');
            }
		},
	 	onChange: function(value) {
	 		const $selectValue = $(this.$wrapper).parent().find('.js-select-value');

			if ($selectValue.length) {
				$selectValue.val(value);
			}
	    },
	});

	/*const urls = {
		qualification: 'https://swapi.dev/api/people/',
	}*/
    const urls = {
        qualification: '/ajax/pk_search.php',
    }

	$(".js-select-ajax").selectize({
		create: false,
    	sortField: 'text',
		onInitialize() {
			const selectType = this.$input.data('type');
			const url = urls[selectType];

			this.settings.placeholder = 'Загрузка';
			this.updatePlaceholder();

			fetch(url)
				.then(res => res.json())
				.then(data => {

				    console.log(data);
					// удалить
					const formatData = data.map((pk, i) => ({
						text: pk.UF_NAME,
						value: pk.ID
					}));
					// 
					this.addOption(formatData)
					this.settings.placeholder = 'Выберите из списка'
					this.updatePlaceholder()

				})
				.catch(e => {
					this.settings.placeholder = 'Ошибка загрузки'
					this.updatePlaceholder()
					console.error(e);
				}) 
		},
	});

	// Inputs masks

	$("form").on("focus", "._mask-tel", function () {
		inputMasked();
	});

	inputMasked();

	// fixed header
	$(window).scroll(function () {
		if($(window).scrollTop() >= 1) {
			$("header").addClass("active fixed-header");
		} else {
			$("header").removeClass("active fixed-header");
		}
	});

	// mobile menu
	$("#menuToggler").change(function () {
		if($(this).is(":checked")) {
			$("body").css("overflow", "hidden");
		} else {
			$("body").css("overflow", "");
		}
	});

	// slider for mobile
	$(".mobSlider").slick({
		responsive: [{
			breakpoint: 9999,
			settings: "unslick"
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false
			}
		}]
	});

	$('.js-popular-programs').on('change', function() {
		const $this = $(this);
		let isLoading = false;

		if (isLoading) {
			return;
		}

		$.ajax({
			method: 'GET',
			url: $this.data('ajax-url'),
			data: { program_id: Number($this.val()) },
			beforeSend: () => {
				isLoading = true;
			},
			success: resp => {
				const $popularProgramsContent = $('.js-popular-programs-content');

				if (!resp) {
					const notFound = `<div class="popular-programs__not-found">
						По&nbsp;результатам анализа востребовательности размещенных образовательных программ, в&nbsp;данном блоке будут выведены анонсы востребовательных программ, со&nbsp;следующей информацией: название программы, тип программы, количество просмотров, длительность обучения, форма обучения, контактная информация.
					</div>`;

					$popularProgramsContent.html(notFound);
				} else {
					$('.js-popular-programs-content').html(resp);

					initProgramsSlider();
				}
			},
			complete: () => {
				isLoading = false;
			},
			error: (jqXHR, exception) => {
			    console.log(jqXHR);
			}
		});
	});

	initProgramsSlider();

	function initProgramsSlider() {
		$(".js-programs-slider").not('.slick-initialized').slick({
			slidesToShow: 3,
			responsive: [{
				breakpoint: 1123,
				settings: {
					slidesToShow: 2,
				}
			}, {
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}]
		});
	}

	// center-detail page centers slider
	$(".outer-centers__grid_slider").slick({
		autoplay: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		dots: true,
		prevArrow: "<span class='icon-btn btn_blue slider-btn slider-prev'><span><svg class='icon icon-caret'><use xlink:href='#caret'></use></svg></span></span>",
		nextArrow: "<span class='icon-btn btn_blue slider-btn slider-next'><span><svg class='icon icon-caret'><use xlink:href='#caret'></use></svg></span></span>",

		responsive: [{
			breakpoint: 1123,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false
			}
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false
			}
		}]
	});

	// toggle navigation on tablet in acount card
	$(".card-nav__item.current").on("click", function (event) {
		event.preventDefault();
		$(this).toggleClass("active");
		$(this).closest(".card-nav").toggleClass("show");
	});


	// Popups
	// popup policy
	$(".popupPolicyBtn").magnificPopup({
		items: {
			src: ".popupPolicy",
			type: "inline"
		},
		removalDelay: 300,
		mainClass: "mfp-fade"
	});

	// login
	$(".loginPopupBtn").magnificPopup({
		items: {
			src: ".loginPopup",
			type: "inline"
		},
		callbacks: {
			beforeOpen: function () {
				$("html").addClass("noScrollMob");
			},
			beforeClose: function () {
				$("html").removeClass("noScrollMob");
			}
		},
		removalDelay: 300,
		mainClass: "mfp-fade"
	});

	// forgot-password popup
	$(".forgotPassword").on("click", function (event) {
		var $curPopup = $(this).parents(".popup");
		$curPopup.find("._entry-form").toggleClass("hidden");
		$curPopup.find("._forgot-password").toggleClass("hidden");
	});

	// contact form popup
	$(".contactFormBtn").magnificPopup({
		items: {
			src: ".popupFormPopup",
			type: "inline"
		},
		callbacks: {
			beforeOpen: function () {
				$("html").addClass("noScroll");
			},
			beforeClose: function () {
				$("html").removeClass("noScroll");
			}
		},
		removalDelay: 300,
		mainClass: "mfp-fade"
	});

    function setDataPopup() {
        let $spherePopup = $('.js-sphere-popup');
        let $specialistSelect = $('.js-specialist-select');
        let id = $specialistSelect.val();
        let name = $specialistSelect.find("[value=\"" + id + "\"]").text();

        $spherePopup.find('[data-parent]').removeClass('_active');
        $spherePopup.find("[data-parent=\"" + name + "\"]").addClass('_active');
    }


    // popup sfera obrazovania
    $(".js-slave-field").magnificPopup({
        items: {
            src: "/include/popup_specialty.php",
            type: "ajax"
        },
        removalDelay: 300,
        mainClass: "mfp-fade",
        callbacks: {
            ajaxContentAdded: function() {
                setDataPopup();
            }
        },
        disableOn: function disableOn() {
            if ($('.js-slave-field').hasClass('_disabled')) {
                return false;
            }
            return true;
        },
        enaTest: function enaTest() {}
    });

    let $masterField = $('select.js-master-field');
    let parentFieldSel = '.js-parent-fields';
    let slaveFieldSel = '.js-slave-field';
    let disabledCls = '_disabled';

    $masterField.each(function () {
        var $this = $(this);
        var $slaveField = $this.closest(parentFieldSel).find(slaveFieldSel);

        if ($slaveField.length && $this.val() === '') {
            $slaveField.addClass(disabledCls);
        }
    }).on('change', function () {
        var $this = $(this);
        var $slaveField = $this.closest(parentFieldSel).find(slaveFieldSel);

        if ($this.val()) {
            $slaveField.val('');
            $('.js-programm-hidden-input').val('');
            $slaveField.removeClass(disabledCls);
        } else {
            $slaveField.addClass(disabledCls);
        }
    });

	// popup sfera obrazovania
	$(".input-list__popup-input").magnificPopup({
		items: {
			src: ".js-sphere-popup",
			type: "inline"
		},
		removalDelay: 300,
		mainClass: "mfp-fade",
		disableOn: function() {
			if ($spherePopup.attr('data-disabled') === 'true') {
				return false;
			}

			return true;
		},
		enaTest: function(){
		}
    });

	// popup join program

	$(".js-open-select-program-popup").magnificPopup({
		items: {
			src: ".js-select-program-popup",
			type: "inline"
		},
		callbacks: {
			beforeOpen: function () {
				$("html").addClass("noScroll");
			},
			beforeClose: function () {
				$("html").removeClass("noScroll");
			}
		},
		removalDelay: 300,
		mainClass: "mfp-fade"
    });


    $('.js-select-program-form').on('submit', function(e) {
        e.preventDefault();
        let id;
        let count = 0;
        $('.add-offer__program-item').hide();
        $('.add-offer__program-item input').prop('disabled', true);
        $(this).find('[name="programs[]"]:checked').each(function () {
            id = $(this).val();
            count++;
            $(`.add-offer__program-item[data-id=${id}]`).css('display', 'flex').find('input').prop('disabled', false);
        });

        if (count > 0)
            $('.add-offer__title').css('visibility', 'initial')
        else
            $('.add-offer__title').css('visibility', 'hidden');

        if (count > 1)
            $('.add-offer__create').show();
        else
            $('.add-offer__create').hide();

        $.magnificPopup.close();
    });

    // профиль юзера сменить пароль

    $('.js-user-change-password-form').on('submit', function(ev) {
        ev.preventDefault();
        const $form = $(this);
        const password = $form.find('[name="password"]').val();
        const passwordDouble = $form.find('[name="password-double"]').val();

        if(password !== passwordDouble ) {
            $.magnificPopup.open({
                items: {
                    src: '.js-user-change-password-error',
                    type: 'inline',
                }
            });
            return
        }

        if(password === '' && passwordDouble === '') {
            $.magnificPopup.open({
                items: {
                    src: '.js-user-change-password-empty',
                    type: 'inline',
                }
            });
            return
        }

        $.ajax({
            url: $form.attr('action'),
            method: $form.attr('method'),
            data: '',
            success() {
                $.magnificPopup.open({
                    items: {
                        src: '.js-user-change-password-success',
                        type: 'inline',
                    }
                });
                $form.trigger('reset');
            },
            fail() {
                $.magnificPopup.open({
                    items: {
                        src: '.js-user-change-password-fail',
                        type: 'inline',
                    }
                });
            }
        })
    });

    // чат выбор контакта
    $('.js-chat-contact').on('click', function(ev) {
        ev.preventDefault();
        $('.js-chat-contact').removeClass('_active');
        $(this).addClass('_active');

        $('.js-chat').addClass('_selected');
        // ajax запрос
        const height = ($('.js-chat-message-window').height())
        $('.js-chat-message-window').closest('.js-scroll-container').scrollTop(height)
    });

    // чат отправка сообщения
    $('.js-chat-form').on('submit', function(ev) {
        ev.preventDefault();
        // ajax
    });

	// sucess when program was created
	// if ($('.popupSuccesAddProgram').length) {
	//     $.magnificPopup.open({
	//         items: {
	//             src: '.popupSuccesAddProgram',
	//             type: 'inline'
	//         },
	//         callbacks: {
	//             beforeOpen: function() {
	//                 $('html').addClass('noScrollMob');
	//             },
	//             beforeClose: function() {
	//                 $('html').removeClass('noScrollMob');
	//             }
	//         },
	//         removalDelay: 300,
	//         mainClass: 'mfp-fade'
	//     });
	// }

	// sucess when password was created
	$(".demoChangePass").magnificPopup({
		items: {
			src: ".popupChangePass",
			type: "inline"
		},
		callbacks: {
			beforeOpen: function () {
				$("html").addClass("noScrollMob");
			},
			beforeClose: function () {
				$("html").removeClass("noScrollMob");
			}
		},
		removalDelay: 300,
		mainClass: "mfp-fade"
	});

	// filter popup on mobile devices
	$(".filterPopupBtn").magnificPopup({
		items: {
			src: ".filterPopup",
			type: "inline"
		},
		callbacks: {
			beforeOpen: function () {
				$("html").addClass("noScroll");
			},
			beforeClose: function () {
				$("html").removeClass("noScroll");
			}
		}
	});

	if ($("#slider-range").length) {
		const $sliderRange = $("#slider-range");

		// filter prices
		var rangeConfig = $sliderRange.data("range-config") || {};
		var rangeOpts = {
			// range: "min",
			range: true,
			min: 1000,
			max: 50000,
			values: [
				1000, 50000
			],
			step: 100,
			slide: function (event, ui) {
	            for (var i = 0; i < ui.values.length; ++i) {
	            	var $sliderInput = $(".js-slider-input");
	            	var $currentSliderInput = $sliderInput.eq(i);

	            	$currentSliderInput.val(ui.values[i]);

					formatValue($currentSliderInput, $currentSliderInput.data("range"));
	            }
			}
		};

		$sliderRange.slider(Object.assign(rangeOpts, rangeConfig));

		// $(".priceBefore").val("от " + $sliderRange.slider("values", 0));
		// $(".priceAfter").val("до " + $sliderRange.slider("values", 1));

		$(".js-slider-input").on("input", function() {
			var $this = $(this);

			// Разрешаем только цифры, форматируем ввод
		    $this.val($this.val().replace(/[^0-9]/g, ""));
		    formatValue($this, $this.data("range"));

		}).on("change", function() {
	        var $this = $(this);
	        var val = Number($this.val().match(/\d+/g));

	        var minVal = Number($('.js-slider-input[data-value="min"]').val().match(/\d+/g));
	        var maxVal = Number($('.js-slider-input[data-value="max"]').val().match(/\d+/g));

	        // "Валидация" минимального/максимального значения
	        if ($this.data("value") === "min" && val > maxVal) {
	        	val = maxVal;
	        } else if ($this.data("value") === "max" && val < minVal) {
	        	val = minVal;
	        }

	        $this.val(val);
	        formatValue($this, $this.data("range"));

	        $sliderRange.slider("values", $this.data("index"), val);
	    });

		function formatValue(el, text) {
			el.val(`${text} ${el.val()}`);
		}
	}

	function hidePlaceholder() {
		$(".form-input").each(function (index, el) {
			if($(this).val().length) {
				$(this).addClass("hasValue");
			} else {
				$(this).removeClass("hasValue");
			}
		});
	}

	if ($(".form-input").length) {
		hidePlaceholder();
	}

	$(".form-input").on("change", hidePlaceholder);
	$("body").on("change", hidePlaceholder);

	$(".form-btn").on("click", function (event) {
		// event.preventDefault();
		var form = $(this).parents("form");

		var input = form.find(".form-input.required");

		input.each(function () {
			if ($(this).val() == "") {
				$(this).addClass("error");
			}
		});
	});

	// user-agent checked
	var isIE = /Trident/.test(navigator.userAgent);
	if(isIE) {
		$("body").addClass("isIE");
	}

	$(".uploadImage").on("click", function (event) {
		$(".uploadImageInput").trigger("click");
	});
});

// remove all hover on touch devices
function hasTouch() {
	return ("ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
}

if(hasTouch()) {
	// remove all :hover stylesheets
	try {
		// prevent exception on browsers not supporting DOM styleSheets properly
		for(var si in document.styleSheets) {
			var styleSheet = document.styleSheets[si];
			if(!styleSheet.rules)
				continue;

			for(var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
				if(!styleSheet.rules[ri].selectorText)
					continue;

				if(styleSheet.rules[ri].selectorText.match(":hover")) {
					styleSheet.deleteRule(ri);
				}
			}
		}
	} catch (ex) {}
}

const popupOrder = function () {
	const ESC_CODE = 27;
	const $btnOpen = document.querySelectorAll(".js-popup-open");
	const $body = document.querySelector("body");
	const $btnCloses = document.querySelectorAll(".js-popup-close");
	const $popups = document.querySelectorAll(".js-popup");
	let btnOpenCoords = {
		left: 0,
		top: 0
	};

	$btnOpen.forEach(function (elem) {
		elem.addEventListener("click", function () {
			const popupStringSelector = this.getAttribute("data-popup-selector");
			const popupSelector = document.querySelector(`.${popupStringSelector}`);
			const btnOffset = this.getBoundingClientRect();
			const windowY = window.scrollY;
			const windowHalfHeight = window.innerHeight / 2;
			const btnOffsetY = btnOffset.y + windowY - windowHalfHeight;
			btnOpenCoords = {
				left: 0,
				top: btnOffsetY
			};

			popupOpen(popupSelector);
		});
	});

	$btnCloses.forEach(function (elem) {
		elem.addEventListener("click", function () {
			popupClose();
		});
	});

	$(document).on("keydown.js-popup", function onKeyDown(evt) {
		if(evt.keyCode === ESC_CODE) {
			popupClose();
		}
	});

	const popupOpen = function (popupSelector) {
		$body.classList.add("overflow");
		popupSelector.classList.add("active");
	};

	const popupClose = function () {
		$body.classList.remove("overflow");
		window.scroll(btnOpenCoords);

		$popups.forEach(function (elem) {
			elem.classList.remove("active");
		});
	};
};

popupOrder();

$(document).ready(function () {
	let dropzone = function () {
		const dropzones = document.querySelectorAll('.js-dropzone');
		let imgArray = [];
		const dzObj = {};

		const createImgData = (file, dataURL, dropzoneNode) => {
			// get data
			const itemObject = {};

			itemObject.width = file.width;
			itemObject.height = file.height;
			itemObject.size = file.size;
			itemObject.name = file.name;
			itemObject.dataURL = dataURL;

			imgArray.push(itemObject);

			// send to server
			let img_array = imgArray;
			const dropzoneAjaxFile = dropzoneNode.getAttribute('data-url');

			const request = new XMLHttpRequest();

			const url = `${dropzoneAjaxFile}&img_array="${img_array}"`;

			request.open('GET', url);

			request.setRequestHeader('Content-Type', 'application/x-www-form-url');

			request.addEventListener("readystatechange", () => {
				if(request.readyState === 4 && request.status === 200) {}
			});

			request.send();
		};

		dropzones.forEach(function (dropzone, index) {
			dropzone.id = `dropzone${index}`;
			const url = dropzone.getAttribute('data-url');
			let many = dropzone.getAttribute('data-images');
			const manyArr = JSON.parse(many);

			new Dropzone(`#dropzone${index}`, {
				autoProcessQueue: false,
				addRemoveLinks: true,
				url: url,
				uploadMultiple: true,
				parallelUploads: 100,
				maxFiles: 100,
				thumbnailWidth: "200",
				thumbnailHeight: "200",
				acceptedFiles: ".jpeg,.jpg,.png,.gif",
				previewTemplate: `<div class="dz-preview dz-file-preview">
					<div class="dz-image">
						<img data-dz-thumbnail />
					</div>
					<div class="dz-details">
						<div class="dz-size" data-dz-size></div>
						<div class="dz-filename"><span data-dz-name></span></div>
					</div>
				</div>`,
				init: function () {
					const self = this;

					this.on("addedfile", function (file) {
						if (file.id) {
							file.previewElement.setAttribute('data-id', file.id);
						}
					});

					this.on("removedfile", function (file) {
						var id = file.previewElement.dataset.id;

						if (id) {
							var request = new XMLHttpRequest();
							var urlDelete = url + '&id_delete=' + id;

							request.open('GET', urlDelete);

							request.setRequestHeader('Content-Type', 'application/x-www-form-url');

							// request.addEventListener("readystatechange", function () {
							// 	if (request.readyState === 4 && request.status === 200) {
							// 		var response = JSON.parse(request.response);

							// 		// if (response.status && response.status === 'ok') {
							// 			// self.removeFile(file);
							// 		// }
							// 	}
							// });

							request.send();
						}
					});

					this.on("success", function (file) {
						const response = JSON.parse(file.xhr.response);

						if (response) {
							file.previewElement.setAttribute('data-id', response.id);
						}
					});

					$('.js-profile-form').on('submit', function(e) {
                        e.preventDefault();
                        console.log(self.process)
						self.processQueue();
				    });

					function imageShow(arrayItem) {
						const dzItems = dropzone.querySelectorAll('.dz-preview');

						dzItems.forEach((dzItem, index) => {
							dzItem.setAttribute('data-id', manyArr[index].id);
						});
						var mockFile = {
							name: arrayItem.fileName,
							size: arrayItem.size,
							accepted: true,
							kind: 'image',
							upload: {
								filename: arrayItem.name,
							},
							dataURL: arrayItem.imageURL,
							id: arrayItem.id
						};

						self.files.push(mockFile);
						self.emit("addedfile", mockFile);
						self.createThumbnailFromUrl(
							mockFile,
							self.options.thumbnailWidth,
							self.options.thumbnailHeight,
							self.options.thumbnailMethod,
							true,
							function (thumbnail) {
								self.emit('thumbnail', mockFile, thumbnail);
								self.emit("complete", mockFile);
							}, "anonymous");
					}


					if (many) {
						JSON.parse(many).map(function (item, index) {
							imageShow(item);
						});
					}
				},
			});
		});
	};

	dropzone();
});



const datepicker = function () {
	const $datepickersPair = $(".js-datepicker");
	const $datepickersSingle = $(".js-datepicker-single");

	$datepickersPair.each(function (i, $datepicker) {
		const value = $(this).data("value");
		const valueSplited = value.split(".");
		const startDateArr = new Date(valueSplited[2], valueSplited[1], valueSplited[0]);
		const startDate = startDateArr;
		const dp = $("#datepicker" + i + "").datepicker({
			toggleSelected: true,
			onSelect: function onSelect(formattedDate, date, elem) {
				$(this).change();
				const isElemStart = elem.$el[0].classList.contains("js-datepicker-start");

				if(isElemStart) {
					const $currentEndCalendar = $(`#datepicker${i + 1}`);

					$currentEndCalendar.datepicker({
						minDate: date
					});

					$currentEndCalendar.datepicker({
						minDate: date
					}).data("datepicker").selectDate(date);
				}
			}
		}).data("datepicker");
	});

	$datepickersSingle.each(function (i, $datepicker) {
		const value = $(this).data("value");
		const valueSplited = value.split(".");
		const startDateArr = new Date(valueSplited[2], valueSplited[1], valueSplited[0]);
		const startDate = startDateArr;

		const dp = $("#datepicker-single" + i + "").datepicker({
			toggleSelected: true,
			onSelect: function onSelect(formattedDate, date, elem) {
				$(this).change();
			}
		}).data("datepicker");
	});
};

datepicker();


const centersMap = function () {
	ymaps.ready(init);

	function init() {

		if ($('#centers-map').length) {

			const myMap = new ymaps.Map('centers-map', {
					center: [55.76, 37.64],
					zoom: 3
				}, {
					searchControlProvider: 'yandex#search'
				}),
				objectManager = new ymaps.ObjectManager({
					// Чтобы метки начали кластеризоваться, выставляем опцию.
					clusterize: true,
					// ObjectManager принимает те же опции, что и кластеризатор.
					gridSize: 32,
					clusterDisableClickZoom: true
				});


			myMap.behaviors.disable('scrollZoom');

			// Чтобы задать опции одиночным объектам и кластерам,
			// обратимся к дочерним коллекциям ObjectManager.
			objectManager.objects.options.set('preset', 'islands#greenDotIcon');
			objectManager.clusters.options.set('preset', 'islands#greenClusterIcons');
			myMap.geoObjects.add(objectManager);

			const centerMap = document.getElementById('centers-map');
			let address = centerMap.dataset.url;

			const url = new URL(location.href);
			const city = url.searchParams.get('city');

			if (city && city !== 'false') {
				$.ajax({
					method: 'GET',
					url: `https://geocode-maps.yandex.ru/1.x/?apikey=8764165a-f27c-488b-9cfb-f81fe64bb68e&format=json&results=1&kind=locality&geocode=${city}`,
					success: function(result) {
						const { featureMember } = result.response.GeoObjectCollection;

						if (featureMember.length) {
							const coords = featureMember[0].GeoObject.Point.pos.split(' ').reverse();

							myMap.setCenter(coords);
						}
					},
					error: function (request, status, error) {
						console.log(request.responseText);
					}
				});
			}

			$.ajax({
				url: `${address}`
			}).done(function (data) {
				objectManager.add(data);
			});
		}
	}
}

centersMap();


const centersMapToggleShow = function centersMapToggleShow() {
	const toggleBtns = document.querySelectorAll(".js-center-map-toggle");

	toggleBtns.forEach(function (elem) {
		const list = document.querySelector(".js-centers-map-list");
		const items = list.querySelectorAll(".js-centers-map-item");

		elem.addEventListener("click", function () {
			items.forEach(function (el, i) {
				const isActive = el.classList.contains("active");
				if(isActive) {
					el.classList.remove("active");
				} else {
					const toggleText = elem.querySelector('.js-center-map-toggle-text');

					el.classList.add("active");
					if (toggleText) {
						toggleText.innerText = el.dataset.item;
					}
				}
			});
		});
	});
};

centersMapToggleShow();


const singleGallery = function singleGallery() {
	const sliders = $(".js-single-gallery");

	const options = {
		slidesToShow: 1,
		dots: true,
		arrows: false,
		responsive: [{
			breakpoint: 1025,
			settings: {
				variableWidth: true,
				focusOnSelect: true
			}
		}, {
			breakpoint: 768,
			settings: {
				variableWidth: false,
				focusOnSelect: false
			}
		}]
	};

	sliders.slick(options);
};

singleGallery();

const expandOrder = function expandOrder() {
	const elems = document.querySelectorAll(".js-orders-finished");

	elems.forEach(function (elem) {
		const btns = elem.querySelectorAll(".js-orders__btn");
		const content = elem.querySelector(".js-orders-content");

		btns.forEach(function (btn) {
			btn.addEventListener("click", function () {
				const isActive = elem.classList.contains("active");

				if(isActive) {
					elem.classList.remove("active");
				} else {
					elem.classList.add("active");
				}
			});
		});
	});
};

expandOrder();

const tabs = function tabs() {
	$(document).on('click', '[data-tabclass]', function onClick() {
		const $this = $(this);
		const content = $this.data('tabclass');
		const number = $this.data('tabnumber');

		$('[data-tabclass="' + content + '"]').each(function each() {
			const $element = $(this);

			if($element.data('tabnumber') === number) {
				$element.addClass('active').siblings().removeClass('active');
			}
		});

		$('.' + content + ' > [data-tabnumber="' + number + '"]').addClass('active').siblings().removeClass('active');
	});
};

tabs();

const toggleActive = function toggleActive() {
	const elems = document.querySelectorAll('.js-toggle-elem');

	elems.forEach(function (elem) {
		elem.addEventListener("click", function () {
			const $this = this;
			const isActive = this.classList.contains('study-place--active');

			if(isActive) {
				this.classList.remove('study-place--active');
			} else {
				this.classList.add('study-place--active');
			}
		});
	});
};

toggleActive();



const licenceSlider = function licenceSlider() {
	const $sliders = $('.js-licence-slider');
	const options = {
		mobileFirst: true,
		slidesToShow: 3,
		dots: true,
		infinite: false,
		responsive: [

			{
				breakpoint: 769,
				settings: 'unslick'
			},
		]
	};

	$sliders.on('destroy', function (ev, slick) {
		const carousel = $(this);

		const reinit = function () {
			if(slick.activeBreakpoint < window.innerWidth) {
				return;
			}

			carousel.slick(slick.options);
		}

		window.addEventListener('resize', reinit);
	}).slick(options);

	// const initSliders = function () {
	// 	$sliders.each(function () {
	// 		const $slider = $(this);
	//
	// 		$slider.slick(options);
	// 	});
	// };
	//
	// initSliders();
	//
	// const destroySliders = function () {
	// 	$sliders.slick('unslick');
	// };
	//
	// $(window).on('resize', function () {
	// 	const windowWidth = $(window).width();
	// 	const isNotMobile = windowWidth >= 769;
	//
	// 	if(isNotMobile) {
	// 		destroySliders();
	// 	} else {
	// 		initSliders();
	// 	}
	// });
};

licenceSlider();
